




















































import { Component, Vue } from 'vue-property-decorator';
import { AxiosPromise, AxiosResponse } from 'axios';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { colorDefaultData } from '@/componentsV2/molecules/ColorPicker/colorsDictionary';
import ProgressBar from '@/components/molecules/ProgressBar/ProgressBar.vue';

import SmartBusinessSignup from '@/api/SmartBusinessSignup';
import {
  IGenerateBrandedCoinsResponse,
  ILoyaltyAndGiftPercentageRecommendationResponse,
  IOfferRecommendation,
  IOfferRecommendationResponse,
  SmartBusinessSignupData,
  SmartBusinessSignupDataResponse
} from '@/models/smart-business-signup';
import { SpecialOfferTags } from '@/views/Offers/OfferDetail/OfferDetail.vue';
import {
  BirthdayDefaultParameters,
  EOfferTypeEnum,
  IOfferDiscountTypeName,
  EOfferRulesName,
  getOfferTagByType,
  SpecialOfferTypeEnum
} from '@/models/offer';

import ClockIcon from '@/components/icons/ClockSolid.vue';

import flagKeys from '@/constants/flagKeys';
import {
  DEFAULT_BRANDED_COIN_IMAGE,
  DEFAULT_ERROR_RESPONSE,
  SMART_BUSINESS_SIGNUP_MOCK
} from './Constants';
import HTTPStatus from '@/constants/httpStatus';
import { sleep } from '@/utils';
import { OnboardingURL } from '@/views/Onboarding/helpers';
import segmentIo from '@/utils/segment.io';

const ANIMATED_TEXT_LIST = [
  'Building your loyalty journey',
  'Finding the perfect gift cards for you',
  'Your offers are almost ready',
  'Polishing your coin',
  'Your rewards are just a moment away',
  'Unlocking gift card magic... Please wait',
  'Bringing personalized deals for you',
  'Making your coin picture-perfect',
  'Almost there! Building your loyalty benefits',
  'Hold tight! Your gift cards are almost here',
  'Unlocking exclusive offers',
  'Bringing your coin to life'
];
@Component({
  components: {
    Typography,
    ProgressBar,
    ClockIcon
  }
})
export default class AILoading extends Vue {
  service = new SmartBusinessSignup();
  loading = 0;
  trackingTime = 15;
  animatedTextList = ANIMATED_TEXT_LIST;
  currentTextIndex = 0;
  textAnimationIntervalId: NodeJS.Timeout | null = null;
  progressIntervalId: NodeJS.Timeout | null = null;
  isRequestTimeoutExceeded: boolean = false;
  trackingInterval: NodeJS.Timeout | null = null;

  get visibleTexts() {
    const nextIndex =
      (this.currentTextIndex + 1) % this.animatedTextList.length;
    return [
      { text: this.animatedTextList[this.currentTextIndex], type: 'current' },
      { text: this.animatedTextList[nextIndex], type: 'next' }
    ];
  }

  private get onboardingStoreDetailFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  private get getCategory() {
    return this.$store.getters['businessOnboarding/getSelectedCategory'];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get useSmartApis(): boolean {
    return this.flags.includes(
      flagKeys.smartBusinessSignupEnableSmartApisInAISignup
    );
  }

  finished() {
    this.loading = 100;
    this.stopProgressInterval();
    setTimeout(() => {
      this.$router.push(OnboardingURL.AI_CAMPAIGNS);
    }, 1500);
  }

  stopProgressInterval() {
    if (this.progressIntervalId) {
      clearInterval(this.progressIntervalId);
      this.progressIntervalId = null;
    }
  }

  startTextAnimation() {
    const TEXT_DISPLAY_TIME = 3200;

    this.textAnimationIntervalId = setInterval(() => {
      const nextIndex =
        (this.currentTextIndex + 1) % this.animatedTextList.length;
      this.currentTextIndex = nextIndex;
    }, TEXT_DISPLAY_TIME);
  }

  stopTextAnimation() {
    if (this.textAnimationIntervalId) {
      clearInterval(this.textAnimationIntervalId);
      this.textAnimationIntervalId = null;
    }
  }

  initTrackingTime() {
    this.trackingInterval = setInterval(() => {
      segmentIo.track('AI Sign Up | Loading Progress', {
        'Progress Time (s)': this.trackingTime
      });
      this.trackingTime += 15;
    }, 15000);
  }

  stopTrackingInterval() {
    if (this.trackingInterval) clearInterval(this.trackingInterval);
  }

  created() {
    this.getSmartData();
  }

  mounted() {
    this.startTextAnimation();
    this.initTrackingTime();
  }

  beforeDestroy() {
    this.stopProgressInterval();
    this.stopTextAnimation();
    this.stopTrackingInterval();
  }

  setSmartData(smartBusinesData: SmartBusinessSignupData) {
    this.$store.dispatch(
      'businessOnboarding/SET_SMART_BUSINESS_SIGNUP',
      smartBusinesData
    );
  }

  setGeneratedSmartBusinessResponse(
    smartBusinesData: SmartBusinessSignupDataResponse
  ) {
    this.$store.dispatch(
      'businessOnboarding/SET_GENERATED_SMART_BUSINESS_RESPONSE',
      smartBusinesData
    );
  }

  getTagItem(specialType: string) {
    return (
      SpecialOfferTags.filter(
        element => element.specialType === specialType
      )[0] || {}
    );
  }

  mapOffers(
    offerRecommendation: IOfferRecommendationResponse
  ): IOfferRecommendation[] {
    return offerRecommendation.offers.map(offer => {
      const rules = [
        {
          name: EOfferRulesName.COMBINE_RULE,
          value: 'true'
        }
      ];

      if (offer.member_limit) {
        rules.push({
          name: EOfferRulesName.SUPPLY_RULE,
          value: String(offer.member_limit)
        });
      }

      const discount =
        offer.type === EOfferTypeEnum.BIRTHDAY
          ? BirthdayDefaultParameters.discount
          : {
              typeName: IOfferDiscountTypeName.OPEN_TEXT_FIELD,
              originalValue: String(offer.original_price || '0'),
              value: getOfferTagByType(
                offer.special_type as SpecialOfferTypeEnum,
                String(offer.discount_code || offer.discount_value).replace(
                  /[^0-9.]+/g,
                  ''
                )
              )
            };
      let avgDiscountValue = '';
      if (offer.discount_type) {
        avgDiscountValue = String(offer.discount_value).replace(
          /[^0-9.]+/g,
          ''
        );
        discount.typeName =
          offer.discount_type === '$'
            ? IOfferDiscountTypeName.AMOUNT
            : IOfferDiscountTypeName.PERCENTAGE;
      }

      return {
        title: offer.title,
        description: offer.description,
        avgDiscountValue,
        method: 'offline',
        type: offer.type,
        restrictions: offer.restrictions,
        image: { url: offer.image_url },
        productType: this.getTagItem(offer.special_type).type,
        discount,
        rules,
        specialType: offer.special_type,
        enabled: true
      };
    });
  }

  startProgressAnimation() {
    const TOTAL_SECONDS = 120;
    const MAX_LOADING = 90;
    const FRAME_RATE = 1000;
    const TOTAL_FRAMES = TOTAL_SECONDS * (1000 / FRAME_RATE);
    let currentFrame = 0;

    if (this.progressIntervalId) {
      clearInterval(this.progressIntervalId);
    }

    this.progressIntervalId = setInterval(() => {
      if (this.isRequestTimeoutExceeded) {
        this.stopProgressInterval();
        return;
      }

      if (this.loading >= MAX_LOADING) {
        this.loading = MAX_LOADING;
        this.isRequestTimeoutExceeded = true;
        this.stopProgressInterval();
        return;
      }

      const easing = (x: number) => 1 - Math.pow(1 - x, 5);
      const progress = easing(currentFrame / TOTAL_FRAMES);

      this.loading = progress * MAX_LOADING;
      currentFrame++;

      if (currentFrame >= TOTAL_FRAMES) {
        this.stopProgressInterval();
      }
    }, FRAME_RATE);
  }

  mapperSmartBusinessData(
    response: SmartBusinessSignupDataResponse
  ): SmartBusinessSignupData {
    return {
      generateBrandedCoins: {
        color: colorDefaultData.colorHex,
        colorKey: colorDefaultData.colorKey,
        brandedCoinSelected: { url: response.generateBrandedCoins.images[0] },
        images: response.generateBrandedCoins.images
      },
      loyaltyPercentageRecommendation: {
        enabled: true,
        percentage:
          response.loyaltyAndGiftPercentageRecommendation.loyaltyPercentage
      },
      giftPercentageRecommendation: {
        enabled: true,
        percentage:
          response.loyaltyAndGiftPercentageRecommendation.giftPercentage
      },
      offersRecommendation: {
        enabled: true,
        offers: this.mapOffers(response.offersRecommendation)
      }
    };
  }

  normalizeBrandedCoins(
    response: AxiosResponse<IGenerateBrandedCoinsResponse>
  ) {
    if (
      response.status === HTTPStatus.CREATED &&
      Array.isArray(response.data.images)
    ) {
      return response.data;
    } else {
      segmentIo.track('AI Sign Up | Fallback Triggered', {
        Section: 'Branded Coin',
        'Feature Flag Enabled': this.useSmartApis
      });
    }
    return { images: [DEFAULT_BRANDED_COIN_IMAGE] };
  }

  private async handleOfferRecommendationFallback(loyaltyPercentage: number) {
    const fallbackResponse = await this.service.offerRecommendationFallback(
      loyaltyPercentage
    );
    return { offers: [fallbackResponse.data] };
  }

  async getOfferRecommendation(
    isSuccessful: boolean,
    loyaltyPercentage: number,
    offerRecommendationResponse: AxiosResponse<IOfferRecommendationResponse>
  ): Promise<IOfferRecommendationResponse> {
    if (isSuccessful) {
      return offerRecommendationResponse.data;
    } else {
      segmentIo.track('AI Sign Up | Fallback Triggered', {
        Section: 'Offers',
        'Feature Flag Enabled': this.useSmartApis
      });
    }

    return this.handleOfferRecommendationFallback(loyaltyPercentage);
  }

  async createSmartBusinessResponse({
    brandedCoinsResponse,
    loyaltyAndGiftRecommendationResponse,
    offerRecommendationResponse
  }: {
    brandedCoinsResponse: AxiosResponse<IGenerateBrandedCoinsResponse>;
    loyaltyAndGiftRecommendationResponse: AxiosResponse<
      ILoyaltyAndGiftPercentageRecommendationResponse
    >;
    offerRecommendationResponse: AxiosResponse<IOfferRecommendationResponse>;
  }): Promise<SmartBusinessSignupDataResponse> {
    const generateBrandedCoins = this.normalizeBrandedCoins(
      brandedCoinsResponse
    );
    const loyaltyAndGiftRecommendation =
      loyaltyAndGiftRecommendationResponse.data;

    const offersRecommendation = await this.getOfferRecommendation(
      offerRecommendationResponse.status === HTTPStatus.CREATED,
      loyaltyAndGiftRecommendation.loyaltyPercentage,
      offerRecommendationResponse
    );

    return {
      generateBrandedCoins,
      loyaltyAndGiftPercentageRecommendation: loyaltyAndGiftRecommendation,
      offersRecommendation
    };
  }

  async getSmartBusinessSignupData(): Promise<SmartBusinessSignupData> {
    const isLocalhost = window.location.hostname === 'localhost';
    if (isLocalhost) {
      return new Promise(resolve => {
        setTimeout(() => {
          this.setGeneratedSmartBusinessResponse(SMART_BUSINESS_SIGNUP_MOCK);
          resolve(this.mapperSmartBusinessData(SMART_BUSINESS_SIGNUP_MOCK));
        }, 15000);
      });
    }

    const placeId = this.onboardingStoreDetailFormData.placeId;
    const category = this.getCategory;

    const loyaltyAndGiftPromise = this.service.loyaltyAndGiftPercentageRecommendation(
      category.name
    );
    const brandedCoinsPromise = this.useSmartApis
      ? this.service.generateBrandedCoins(placeId)
      : sleep(10000).then(
          () =>
            Promise.resolve(DEFAULT_ERROR_RESPONSE) as AxiosPromise<
              IGenerateBrandedCoinsResponse
            >
        );
    const offerRecommendationPromise = this.useSmartApis
      ? this.service.offerRecommendation(placeId)
      : (Promise.resolve(DEFAULT_ERROR_RESPONSE) as AxiosPromise<
          IOfferRecommendationResponse
        >);

    const [
      loyaltyAndGiftRecommendationResponse,
      brandedCoinsResponse,
      offerRecommendationResponse
    ] = await Promise.all([
      loyaltyAndGiftPromise,
      brandedCoinsPromise,
      offerRecommendationPromise
    ]);

    const response = await this.createSmartBusinessResponse({
      brandedCoinsResponse,
      loyaltyAndGiftRecommendationResponse,
      offerRecommendationResponse
    });

    this.setGeneratedSmartBusinessResponse(response);

    return this.mapperSmartBusinessData(response);
  }

  async getSmartData() {
    this.startProgressAnimation();

    const smartBusinessData = await this.getSmartBusinessSignupData();

    this.setSmartData(smartBusinessData);
    this.finished();
  }

  skip() {
    segmentIo.track('AI Sign Up | Loading Skip Clicked');
    this.$router.push(OnboardingURL.USER_SIGN_UP);
  }
}
